import React from "react";
import { ApiService } from "../../services/api_service";
import { LegalPage, PointParagraph, useLegalDocument } from "../legal/LegalPage";

/**
 * Privacy Policy — mirrors the mobile app's Privacy Policy screen.
 *
 * All copy comes from `GET /privacy-policy`; nothing is hardcoded here. Page
 * chrome, the fetch behaviour and point rendering are shared with the Terms &
 * Conditions page (see ../legal/LegalPage).
 *
 * A section carries flat `points`, nested `subModels`, or (in principle) both.
 * Today every section uses exactly one of the two, but both branches are kept
 * conditional as the app does, so a section shipping both still renders.
 */

const PolicySection = ({ section }) => (
  <li className="policy-section">
    {/* Unlike the Terms page, section titles are never numbered. */}
    <h2 className="legal-section-title">{section.title}</h2>

    {section.points?.length > 0 && (
      <div className="legal-block legal-points">
        {section.points.map((p, i) => (
          <PointParagraph key={i} header={p.header} point={p.point} />
        ))}
      </div>
    )}

    {section.subModels?.length > 0 && (
      <div className="legal-block legal-sub-sections">
        {section.subModels.map((sub, i) => (
          <div key={i}>
            <h3 className="legal-subtitle">{sub.subtitle}</h3>
            <div className="legal-points">
              {sub.pointModels.map((p, j) => (
                <PointParagraph key={j} header={p.header} point={p.point} />
              ))}
            </div>
          </div>
        ))}
      </div>
    )}
  </li>
);

const Privacypolicy = () => {
  const { status, data, retry } = useLegalDocument(
    ApiService.getPrivacyPolicy,
    "privacy policy"
  );

  return (
    <LegalPage
      title="Privacy Policy"
      documentName="privacy policy"
      status={status}
      onRetry={retry}
    >
      {/* Response order is display order — `id` is a key, never a sort key. */}
      {data.map((section) => (
        <PolicySection key={section.id} section={section} />
      ))}
    </LegalPage>
  );
};

export default Privacypolicy;
